import type { SVGProps } from 'react'

export const MusicSongFavouriteLike = (props: SVGProps<SVGSVGElement>) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M21.6674 35.2726H11.3965C7.71329 35.2726 4.72705 32.2864 4.72705 28.6032V11.396C4.72705 7.71281 7.71329 4.72656 11.3965 4.72656H28.6037C32.2869 4.72656 35.2731 7.71281 35.2731 11.396V19.9996"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.8377 26.1779C31.2846 25.681 32.0566 25.1191 33.2337 25.1191C35.2912 25.1191 36.6735 26.9599 36.6735 28.674C36.6718 32.2588 31.9915 35.0049 30.8377 35.0049C29.6839 35.0049 25.002 32.2588 25.002 28.6756C25.002 26.9599 26.3825 25.1208 28.4417 25.1208C29.6172 25.1208 30.3909 25.681 30.8377 26.1779Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4538 13.5359L25.8687 17.9347C26.3633 18.1929 26.6667 18.6623 26.6667 19.1693C26.6667 19.6763 26.3633 20.1456 25.8687 20.4038L17.4538 24.8026C16.9501 25.0657 16.325 25.0695 15.8172 24.8126C15.3093 24.5557 14.9972 24.0778 15 23.5614V14.7638C15.0027 14.2497 15.3169 13.7762 15.8237 13.5226C16.3306 13.269 16.9524 13.2741 17.4538 13.5359Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
